// @flow

import React, { Component }          from 'react';
import { connect }                   from 'react-redux';
import Routes                        from './routes.js';
import Navigation                    from 'components/common/navigation/navigation';
import GoTop                         from 'components/common/goTop/goTop';
import { getTranslate }              from 'react-localize-redux';
import { userGet, userApplications } from 'actions/user/user';
import { getFAQ }                    from 'actions/faq/faq';
import { userGetScopes }             from 'actions/user/user';
import ReactLoading                  from 'react-loading';
import Footer                        from 'components/common/footer';
import './index.css';

class Main extends Component {

  state = {
    isLoading: true
  }

  componentWillMount() {
    const { dispatch } = this.props;
    dispatch(userGetScopes());
    dispatch(userGet());
    dispatch(userApplications());
    dispatch(getFAQ());
  }

  componentWillReceiveProps(nextProps) {
    const { app } = nextProps;

    if( app.application.loading === false && app.applications.loading === false ) {
      this.setState({ isLoading: false });
    }
  }
  render() {
    const { isLoading } = this.state;
    const { translate } = this.props;
    return (
      <div className="main">
        <div id="wrapper">
          <GoTop positionx='right' positiony='bottom' scrolloffset='100' />
          <Navigation />
          <div className="container-fluid">
            {isLoading ? (
              <div className='row text-center'>
                <ReactLoading type='spin' height='34px' width='34px' color='#8bb91d' className='loading-icon inline-centered' />
              </div>
              ) : (
                <Routes />
              )
            }
          </div>
          <Footer translate={translate} />
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  translate: getTranslate(state.locale),
  app: state.application,
  user: state.user,
});

export default connect(mapStateToProps)(Main);



// WEBPACK FOOTER //
// ./src/components/main/index.js